import * as React from 'react'

const ImageIcon = props => (
  <svg
    width={props.width}
    height={props.height}
    viewBox={'0 0 32 32'}
    {...props}
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M21.333 30.333H10.667C5.8 30.333 3 27.533 3 22.667V9.333c0-4.866 2.8-7.666 7.667-7.666h10.666C26.2 1.667 29 4.467 29 9.333v13.334c0 4.866-2.8 7.666-7.667 7.666zM10.667 3.667C6.853 3.667 5 5.52 5 9.333v13.334c0 3.813 1.853 5.666 5.667 5.666h10.666c3.814 0 5.667-1.853 5.667-5.666V9.333c0-3.813-1.853-5.666-5.667-5.666H10.667z'
      fill={props.fill}
    />
    <path
      d='M24.667 12.333H22a3.665 3.665 0 0 1-3.667-3.666V6c0-.547.454-1 1-1 .547 0 1 .453 1 1v2.667c0 .92.747 1.666 1.667 1.666h2.667c.546 0 1 .454 1 1 0 .547-.454 1-1 1zm-8.667 6h-5.333c-.547 0-1-.453-1-1 0-.546.453-1 1-1H16c.547 0 1 .454 1 1 0 .547-.453 1-1 1zm5.333 5.334H10.667c-.547 0-1-.454-1-1 0-.547.453-1 1-1h10.666c.547 0 1 .453 1 1 0 .546-.453 1-1 1z'
      fill={props.fill}
    />
  </svg>
)

ImageIcon.defaultProps = {
  width: 32,
  height: 32,
  fill: '#475569'
}

export { ImageIcon }
